import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { SessionTokenGuard } from '../shared/router/guard/session';

export const DashboardRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [ SessionTokenGuard ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'campaign',
        canActivate: [ SessionTokenGuard ]
      },
      {
        path: 'campaign',
        loadChildren: '../module/campaign/campaign.module#CampaignModule',
        canActivate: [ SessionTokenGuard ]
      },
      {
        path: '',
        loadChildren: '../module/account/account.module#AccountModule',
        canActivate: [ SessionTokenGuard ]
      }
    ]
  }
];
